module.exports = __webpack_public_path__ + "static/clear-error.11ff69ba.png";